import moment from 'moment';
import { Document } from '../..';

export const getDueDateStatus = (dueDate : Date | null, done : boolean) => {
    if (done) {
        return 'done'
    }

    const today = moment(Date.now())
    const dueDateMoment = moment(dueDate)

    if (today.isAfter(dueDateMoment)) {
        return 'dueDatePassed'
    }

    const result = dueDateMoment.diff(today, 'hours')
    if (result < 24) {
        return 'dueDateSoon'
    }

    return 'regular'
}

 export const getDueDateStyling = (dueDate: Date | null, done: boolean) => {

    const defaultCheckboxColor = 'white'
    const defaultTextColor = 'white'

    switch (getDueDateStatus(dueDate, done)) {
        case 'done':
            const green = '#3ece5a'
            return { backgroundColor: green, checkboxColor: defaultCheckboxColor, textColor: defaultTextColor }
        case 'dueDatePassed':
            return { backgroundColor: 'red', checkboxColor: defaultCheckboxColor, textColor: defaultTextColor }
        case 'dueDateSoon':
            return { backgroundColor: 'orange', checkboxColor: defaultCheckboxColor, textColor: defaultTextColor }
        default:
            const gray = '#e3e3e3'
            return { backgroundColor: gray, checkboxColor: 'rgba(48, 47, 71, 0.54)', textColor: '#21212d' }
    }
}

export const getDueDate = (item: Document, format = 'DD/MM/YYYY, HH:mm') => {
    const dueDateUTC = item.dueDateUTC

    if (!dueDateUTC) {
        return null
    }

    const zeroDateTime = new Date('0001-01-01T00:00:00Z')
    if (dueDateUTC === zeroDateTime) {
        return null
    }

    return  moment(dueDateUTC).format(format)
}


export const timeSince = (date : Date) => {
    if (typeof date !== 'object') {
      date = new Date(date);
    }

    let seconds = Math.floor((new Date().getTime() - date.getTime()) / 1000);
    let intervalType;
  
    let interval = Math.floor(seconds / 31536000);
    if (interval >= 1) {
      intervalType = 'y';
    } else {
      interval = Math.floor(seconds / 2592000);
      if (interval >= 1) {
        intervalType = 'm';
      } else {
        interval = Math.floor(seconds / 86400);
        if (interval >= 1) {
          intervalType = 'd';
        } else {
          interval = Math.floor(seconds / 3600);
          if (interval >= 1) {
            intervalType = "h";
          } else {
            interval = Math.floor(seconds / 60);
            if (interval >= 1) {
              intervalType = "m";
            } else {
              interval = seconds;
              intervalType = "now";
            }
          }
        }
      }
    }

    return interval + intervalType;
  };